// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapsable_root__2VEpi","title":"Collapsable_title__3m7eY","icon":"Collapsable_icon__3xbt5","body":"Collapsable_body__3TW9U","open":"Collapsable_open__4VBko"};